import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  AdminPageTitle,
  AdminDetailFieldLabel,
  AdminSupportingText,
  AdminHeaderAction,
  AdminLinkAction,
  adminWizardInputClasses,
  adminWizardTextareaClasses,
} from "../AdminDashboard/shared/adminUx";
import { POPUP_FORM_CONTENT_WIDTH_CLASS } from "../../components/popup/popupLayoutSpec";

const VerificationPopUp = ({
  firstMainHeading,
  secondMainHeading,
  firstP,
  Headingh6,
  Headingh5,
  secondHeadingh6,
  secondHeadingh5,
  secondP,
  placeholder,
  label,
  closePopup,
  smallPara,
  resendButton,
  buttonText,
}) => {
  const [step, setStep] = useState(1);
  const [fieldValue, setFieldValue] = useState("");
  const location = useLocation();

  const isReviewsInbox = location.pathname === "/business-dashboard/inbox/reviews";
  const isLinkFlow =
    location.pathname.includes("/settings/social-profiles") ||
    location.pathname.includes("/settings/associations") ||
    location.pathname.includes("/Review");

  const submitLabel = isLinkFlow ? buttonText || "Save" : "Submit";

  const handleSubmit = () => {
    setStep(2);
    setTimeout(closePopup, 3000);
  };

  const titleVariant = Headingh5 || secondHeadingh5 ? "pb-0" : "pb-0";

  return (
    <>
      {step === 1 && (
        <div className={`${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto`}>
          {!Headingh6 && !Headingh5 && (
            <AdminPageTitle className={`text-center text-offblack mb-10 ${titleVariant}`}>
              {firstMainHeading}
            </AdminPageTitle>
          )}
          {Headingh5 ? (
            <AdminPageTitle className="text-center text-offblack mb-10">
              {firstMainHeading}
            </AdminPageTitle>
          ) : null}
          <div className="mx-auto rounded-lg mb-4 w-full">
            {firstP ? (
              <AdminSupportingText className="text-offblack block text-start">
                {firstP}
              </AdminSupportingText>
            ) : null}

            <div className="mt-10 w-full space-y-1">
              <AdminDetailFieldLabel htmlFor="verification-field">{label}</AdminDetailFieldLabel>
              {isReviewsInbox ? (
                <textarea
                  id="verification-field"
                  placeholder={placeholder}
                  value={fieldValue}
                  onChange={(e) => setFieldValue(e.target.value)}
                  className={adminWizardTextareaClasses(false)}
                  rows={4}
                  style={{ resize: "none" }}
                />
              ) : (
                <input
                  id="verification-field"
                  type="text"
                  placeholder={placeholder}
                  value={fieldValue}
                  onChange={(e) => setFieldValue(e.target.value)}
                  className={adminWizardInputClasses(false)}
                />
              )}
            </div>

            {smallPara ? (
              <AdminSupportingText className="text-mediumgray block text-start mt-5">
                {smallPara}
              </AdminSupportingText>
            ) : null}

            {isLinkFlow ? (
              <div className="flex items-center justify-end mt-10">
                <AdminHeaderAction type="button" onClick={handleSubmit}>
                  {submitLabel}
                </AdminHeaderAction>
              </div>
            ) : (
              <div
                className={
                  !resendButton
                    ? "flex items-center justify-between mt-10"
                    : "flex items-center justify-end mt-10"
                }
              >
                {!resendButton ? (
                  <div className="flex items-center gap-2">
                    <AdminSupportingText className="text-mediumgray">
                      Didn&apos;t get the code?
                    </AdminSupportingText>
                    <AdminLinkAction type="button">Resend</AdminLinkAction>
                  </div>
                ) : null}
                <AdminHeaderAction type="button" onClick={handleSubmit}>
                  {submitLabel}
                </AdminHeaderAction>
              </div>
            )}
          </div>
        </div>
      )}

      {step === 2 && (
        <div className={`${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto`}>
          {!secondHeadingh6 && !secondHeadingh5 && (
            <AdminPageTitle className="text-center text-offblack mb-10">
              {secondMainHeading}
            </AdminPageTitle>
          )}
          {secondHeadingh5 ? (
            <AdminPageTitle className="text-center text-offblack mb-10">
              {secondMainHeading}
            </AdminPageTitle>
          ) : null}
          <AdminSupportingText className="text-offblack block text-start">
            {secondP}
          </AdminSupportingText>
          <div className="flex justify-center mt-10">
            <i className="fi fi-ss-badge-check text-[50px] text-primaryblue" aria-hidden />
          </div>
        </div>
      )}
    </>
  );
};

export default VerificationPopUp;
